export default __webpack_public_path__ + "static/media/nabeel.30c66c9a.png";